import React from 'react';
interface EyebrowProps {
  children: React.ReactNode;
  className?: string;
  light?: boolean;
}
export function Eyebrow({
  children,
  className = '',
  light = false
}: EyebrowProps) {
  return <span className={`font-mono-eyebrow text-xs font-semibold uppercase tracking-[0.25em] ${light ? 'text-brand-blue' : 'text-brand-blue'} ${className}`} data-id="element-19" data-mp="1bw4harskx9ag">
      {children}
    </span>;
}